<template>
  <div class="card-container">
    <v-container fluid class="header-card">
      <v-layout fill-height>
        <v-flex xs12 align-end flexbox>
          <span class="text-header">Penalty</span>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="dialog" persistent width="800">
      <template v-slot:activator="{ on }">
        <v-container
          fluid
          style="display: flex; align-items: center; justify-content: flex-end"
        >
          <v-btn
            v-if="penalty_state.length != 0"
            append
            flat
            class="edit-btn"
            v-on="on"
          >
            <v-icon style="margin-right: 5px">edit</v-icon>Edit
          </v-btn>
          <v-btn v-else append flat class="edit-btn" v-on="on">
            <v-icon style="margin-right: 5px">edit</v-icon>Create
          </v-btn>
        </v-container>
      </template>

      <v-card>
        <v-card-title class="headline primary" primary-title>
          <div style="font-size: 2rem; font-weight: bold">Edit Penalty</div>
          <v-spacer></v-spacer>
          <div>
            <v-btn icon large @click="resetPenaltyListsStateAndClose">
              <v-icon large> mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <div style="margin-top: 25px"></div>
        <div
          style="
            font-size: 20px;
            font-weight: bold;
            padding-inline: 30px;
            padding-top: 10px;
          "
          v-for="(penalty_list, index) in penalty_lists"
          :key="index"
        >
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: flex-end;
            "
          >
            Penalty {{ penalty_list.penalty_time }}

            <v-btn
              append
              flat
              class="remove-btn"
              @click="removePenaltyLists(penalty_list.penalty_time - 1)"
            >
              <v-icon style="margin-right: 5px">delete</v-icon> Remove
            </v-btn>
          </div>

          <div style="display: flex; padding-top: 20px">
            <div class="front-text" style="padding-top: 3px">
              Penalty type :
            </div>
            <v-radio-group
              v-model="penalty_list.penalty_type"
              row
              style="margin: 0"
            >
              <v-radio color="primary" :label="`Credit`" :value="1"></v-radio>
              <v-radio color="primary" :label="`Percent`" :value="2"></v-radio>
            </v-radio-group>
          </div>
          <div style="display: flex; width: 100%">
            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                width: 50%;
              "
            >
              <div class="front-text" style="padding-top: 12px">Amount</div>
              <div style="display: flex; margin-top: 10px">
                <div style="width: 100%" v-if="penalty_list.penalty_type == 1">
                  <v-text-field
                    autofocus
                    @keypress="isNumber($event)"
                    :rules="
                      penalty_list.penalty_type == 1
                        ? [rules.required]
                        : [rules.required, rules.percentRule]
                    "
                    label="Enter number"
                    v-model="penalty_list.penalty_amount"
                    suffix="Credit"
                    solo
                  ></v-text-field>
                </div>
                <div style="width: 100%" v-else>
                  <v-text-field
                    autofocus
                    @keypress="isNumber($event)"
                    :rules="
                      penalty_list.penalty_type == 1
                        ? [rules.required]
                        : [rules.required, rules.percentRule]
                    "
                    label="Enter number"
                    v-model="penalty_list.penalty_amount"
                    suffix="%"
                    solo
                  ></v-text-field>
                </div>
              </div>
            </div>
            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                width: 30%;
              "
            >
              <div class="front-text" style="padding-top: 12px">
                {{
                  penalty_list.penalty_time === 1
                    ? "Start Penalty After"
                    : "Increase Penalty After"
                }}
              </div>
              <div style="display: flex; margin-top: 10px">
                <div style="width: 100%">
                  <v-text-field
                    autofocus
                    @keypress="isNumberWithoutDot($event)"
                    :rules="
                      penalty_list.penalty_type == 1
                        ? [rules.required]
                        : [rules.required, rules.percentRule]
                    "
                    label="Enter number"
                    v-model="penalty_list.penalty_after_day"
                    suffix="Days"
                    solo
                  ></v-text-field>
                </div>
              </div>
            </div>
          </div>
          <div style="display: flex; width: 100%; justify-content: center">
            <div class="hl"></div>
          </div>
        </div>

        <div
          v-if="penalty_lists.length < 5"
          style="
            display: flex;
            width: 100%;
            justify-content: center;
            margin-top: 30px;
          "
        >
          <v-btn append flat class="add-btn" @click="addPenaltyLists()">
            <v-icon style="margin-right: 5px">control_point</v-icon>
          </v-btn>
        </div>
        <div style="height: 50px"></div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            style="
              background-color: black;
              color: white;
              padding-inline: 50px;
              border-radius: 5px;
              margin: 15px;
            "
            flat
            @click="updateWithdrawCommission()"
          >
            Confirm
          </v-btn>
        </v-card-actions>

        <v-dialog v-model="dialog_error" width="400">
          <v-card>
            <v-card-title class="headline primary" primary-title>
              <div style="font-size: 2rem; font-weight: bold">Error</div>
            </v-card-title>
            <div
              style="
                font-size: 20px;
                padding-inline: 30px;
                padding-top: 30px;
                margin-bottom: 30px;
              "
            >
              {{ error_text }}
            </div>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="color: red" flat @click="dialog_error = false">
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </v-dialog>
    <div v-if="penalty_state.length != 0">
      <div v-for="(list, index) in penalty_state" :key="index">
        <div style="padding-inline: 3vw; margin-bottom: 25px">
          <div
            style="
              background-color: #f2f2f2;
              width: 100%;
              padding-block: 10px;
              padding-inline: 2vw;
              border-radius: 5px;
              border-color: #00000029 1px 1px;
              box-shadow: #00000029 1px 2px 7px;
            "
          >
            <v-container fluid>
              <v-layout row>
                <v-flex shrink mr-5>
                  <div
                    style="
                      display: flex;
                      width: 100%;
                      height: 100%;
                      align-items: center;
                      font-weight: bolder;
                      font-size: 1.8rem;
                    "
                  >
                    Penalty {{ list.penalty_time }}
                  </div>
                </v-flex>
                <div class="vl"></div>
                <v-flex grow pa-1 style="display: flex; align-items: center">
                  <v-layout row>
                    <v-flex md4 pa-1>
                      <div style="display: flex; flex-direction: column">
                        <span class="headder-text"> Penalty Type </span>
                        <span style="font-weight: bolder; font-size: 1.4rem">{{
                          list.penalty_type == 1 ? "Credit" : "Percent"
                        }}</span>
                      </div>
                    </v-flex>
                    <v-flex md4 pa-1>
                      <div style="display: flex; flex-direction: column">
                        <span class="headder-text"> Amount </span>
                        <span style="font-weight: bolder; font-size: 1.4rem">
                          {{ list.penalty_amount }}
                        </span>
                      </div>
                    </v-flex>
                    <v-flex md4 pa-1>
                      <div style="display: flex; flex-direction: column">
                        <span class="headder-text"> Start Penalty After </span>
                        <span style="font-weight: bolder; font-size: 1.4rem">
                          {{ list.penalty_after_day }}
                        </span>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      style="
        display: flex;
        width: 100%;
        justify-content: center;
        align-items: center;
        height: 50vh;
        font-weight: 500;
        font-size: 4rem;
        color: #cccccc;
      "
    >
      No penalty
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      dialog: false,
      dialog_error: false,
      penalty_lists: [],
      penalty_temp: [],
      error_text: "กรุณากรอกข้อมูลให้ครบ",
      isNumber(evt) {
        const charCode = evt.which ? evt.which : evt.keyCode;
        if (
          charCode > 31 &&
          (charCode < 48 || charCode > 57) &&
          charCode !== 46
        ) {
          evt.preventDefault();
        }
        console.log(this.penalty_state[0].penalty_amount);
      },
      isNumberWithoutDot(evt) {
        const charCode = evt.which ? evt.which : evt.keyCode;
        if (evt.keyCode == 110 || evt.keyCode == 190) {
          console.log("YES");
        }
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          evt.preventDefault();
        }
      },
      rules: {
        required: (value) => {
          if (value === "") return "Required.";
          else return true;
        },
        percentRule: (value) => {
          if (!isNaN(parseFloat(value)) && value >= 0 && value <= 100)
            return true;
          return "Please enter number 0-100";
        },
      },
    };
  },
  computed: {
    ...mapState({
      penalty_state: (state) => state.fetchRiderCommission.penalty,
    }),
  },
  created() {
    this.getPenalty();
  },
  methods: {
    addPenaltyLists() {
      this.penalty_lists.push({
        penalty_time: this.penalty_lists.length + 1,
        penalty_type: 1,
        penalty_amount: 0,
        penalty_after_day: 1,
      });
    },
    removePenaltyLists(index) {
      this.penalty_lists.splice(index, 1);
      let penalty = this.penalty_lists;
      this.penalty_lists = [];
      for (let index = 0; index < penalty.length; index++) {
        this.penalty_lists.push({
          penalty_time: index + 1,
          penalty_type: penalty[index].penalty_type,
          penalty_amount: penalty[index].penalty_amount,
          penalty_after_day: penalty[index].penalty_after_day,
        });
      }
    },
    async getPenalty() {
      const province = this.$route.params.province;
      let res = await this.$store.dispatch(
        "fetchRiderCommission/getPenalty",
        province
      );
      if (res == false) {
      } else {
        this.penalty_lists = res;
        this.penalty_temp = this.penalty_state;
      }
    },
    async resetPenaltyListsStateAndClose() {
      this.dialog = false;
      this.getPenalty();
    },
    async updateWithdrawCommission() {
      for (let index = 0; index < this.penalty_lists.length; index++) {
        if (this.penalty_lists[index].penalty_after_day == 0) {
          this.error_text =
            "ใน Penalty " + (index + 1) + " ใส่จำนวนวัน เท่ากับ 0 ไม่ได้";
          this.dialog_error = true;
          return;
        }
        if (this.penalty_lists[index].penalty_after_day.length == 0) {
          this.error_text =
            "กรุณาใส่จำนวนวัน (Start/Increase Penalty After) ใน Penalty " +
            (index + 1) +
            " ให้เรียบร้อย";
          this.dialog_error = true;
          return;
        }
        if (
          parseInt(this.penalty_lists[index].penalty_amount) > 100 &&
          this.penalty_lists[index].penalty_type == 2
        ) {
          this.error_text =
            "กรุณาตรวจสอบ Amount ใน Penalty " + (index + 1) + " ให้ถูกต้อง";
          this.dialog_error = true;

          return;
        }
        if (
          parseInt(this.penalty_lists[index].penalty_amount) == 0 &&
          this.penalty_lists[index].penalty_type == 2
        ) {
          this.error_text =
            "Amount ใน Penalty " +
            (index + 1) +
            " เป็น 0 ไม่ได้ กรุณาตรวจสอบให้ถูกต้อง";
          this.dialog_error = true;

          return;
        }
        if (
          this.penalty_lists[index].penalty_amount.length == 0 ||
          parseInt(this.penalty_lists[index].penalty_amount) == 0
        ) {
          this.error_text =
            "กรุณาตรวจสอบ Amount ใน Penalty " + (index + 1) + " ให้ถูกต้อง";
          this.dialog_error = true;

          return;
        }
      }
      let form = {
        penalty: this.penalty_lists,
      };
      let payload = {
        body: form,
        data_save: this.penalty_lists,
      };
      const province = this.$route.params.province;
      let check = await this.$store.dispatch(
        "fetchRiderCommission/updatePenalty",
        { payload, province }
      );
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.card-container {
  border-radius: 5px;
  margin-top: 1px;
  margin-bottom: 30px;
  height: 100%;
  width: 100%;
  background-color: #ffffff;
  box-shadow: 0px 0px 5px 2px #00000029;
}

.header-card {
  border-radius: 5px 5px 0px 0px;
  width: 100%;
  height: 7vh;
  background-color: #ffd600;
  text-align: center;
  box-shadow: 0 4px 5px -2px #00000029;
}

.text-header {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 2rem;
}

.edit-btn {
  background-color: black;
  color: white;
  font-weight: bold;
  font-size: 1.2rem;
  border-radius: 7px;
  letter-spacing: 1.15px;
  width: 130px;
  display: flex;
  padding-block: 20px;
}

.remove-btn {
  background-color: #ff6060;
  color: white;
  border-radius: 7px;
  width: 120px;
  display: flex;
  padding-block: 10px;
}

.add-btn {
  color: #4a4a4e;
  width: 120px;
}

.front-text {
  margin-right: 15px;
  font-weight: 600;
  font-size: 1.2rem;
  color: #4a4a4e;
}

.data-text {
  font-weight: bold;
  font-size: 1.2rem;
}

.disable-text {
  padding: 15px 10px 30px 30px;
  color: #c2c2c2;
  font-weight: 600;
  font-size: 1.2rem;
}

.headder-text {
  margin-bottom: 15px;
  font-size: 1rem;
}

.vl {
  border-left: 1px solid #dbdbdb;
  height: 100px;
  margin-inline: 20px;
  margin-right: 40px;
}

.hl {
  border-bottom: 1px solid #f2f2f2;
  width: 90%;
}
</style>
